import { render, staticRenderFns } from "./commonTable.vue?vue&type=template&id=7fb36e82&scoped=true"
import script from "./commonTable.vue?vue&type=script&lang=js"
export * from "./commonTable.vue?vue&type=script&lang=js"
import style0 from "./commonTable.vue?vue&type=style&index=0&id=7fb36e82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb36e82",
  null
  
)

export default component.exports